import React from "react";
import { packClasses } from "Utils";

export default function Column(props) {
    return (
        <th
            scope="col"
            colSpan={props.colSpan || 1}
            className={packClasses(
                props.className
                    ? props.className
                    : "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            )}
        >
            {props.onClick ? (
                <span className="cursor-pointer" onClick={props.onClick}>
                    {props.children}
                </span>
            ) : (
                props.children
            )}
        </th>
    );
}
